import { render, staticRenderFns } from "./Recruitment.vue?vue&type=template&id=1abefe07&scoped=true&"
import script from "./Recruitment.vue?vue&type=script&lang=js&"
export * from "./Recruitment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abefe07",
  null
  
)

export default component.exports